import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-confirmationpartn',
  templateUrl: './confirmationpartn.component.html',
  styleUrls: ['./confirmationpartn.component.css']
})
export class ConfirmationpartnComponent {
  status: any = null;

  constructor(private router: Router) { }
  ngOnInit(): void {
    this.status = sessionStorage.getItem('canSuccess');

    if (this.status == undefined) {
      this.router.navigate(['/']);
    }
  }

}
